import { Component, Inject } from "@angular/core";

import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";

import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";

@Component({
  template: require('./extend-trial-period.component.html'),
  styles: [require('./extend-trial-period.component.css')],
  selector: "extend-SyncIt-trial-period",
})
export class ExtendSyncItTrialPeriodComponent {
  SyncITProductLicenseId: any;
  SyncItExtendTrialPeriodForm: FormGroup;
  dialogTitle = "Extend Trial Period";
  errorMessage = "";
  constructor(
    private licenseService: LicenseService,
    private dialogRef: MdDialogRef<ExtendSyncItTrialPeriodComponent>,
    private adalService: AdalService,
    private router: Router,
    private formBuilder: FormBuilder,
    private snackBar: MdSnackBar,
    private appLoader: AppLoaderService,
    @Inject(MD_DIALOG_DATA) public dialogData: any
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.SyncITProductLicenseId = dialogData.payload.SyncITProductLicenseId;
    this.buildForm();

    this.SyncItExtendTrialPeriodForm.get("NoOfMonths").setValidators(
      Validators.required
    );
  }
  buildForm() {
    this.SyncItExtendTrialPeriodForm = this.formBuilder.group({
      NoOfMonths: [
        "",
        [Validators.required, Validators.min(1), Validators.max(120)],
      ],
    });
  }
  onSave() {
      const noOfMonths = this.SyncItExtendTrialPeriodForm.value.NoOfMonths;
     if (!noOfMonths || noOfMonths < 1) {
    this.snackBar.open("Trial months must be at least 1.", "Close", {
      duration: 4000,
    });
    return;
  }
    let model = {
      UpdatedBy: Number(localStorage.getItem("userid")),
      SyncITProductLicenseId: this.SyncITProductLicenseId,
      NoOfMonths: this.SyncItExtendTrialPeriodForm.value.NoOfMonths,
    };
       this.dialogRef.close(model);
    
  }
  onCancel() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/popup/extend-trial-period/extend-trial-period.component.ts